import { Group, GroupModel, FetchFileStatusState, FileStatus } from '../components/groups/interface/Group'
import { BASE_SERVICE_URL } from '../lib/constants'

export function createGroupModel(groupModels: GroupModel) {
    return fetch(BASE_SERVICE_URL + '/groupmodel', {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(groupModels)
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}

export function updateGroupModel(groupModels: GroupModel) {
    return fetch(BASE_SERVICE_URL + '/groupmodel', {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(groupModels)
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}

export function getGroupModeList() {
    return fetch(BASE_SERVICE_URL + '/groupmodellist', {
        credentials: 'same-origin'
    }).then(response => {
        if (response.ok) {
            return response.json()
        }
        const error = new Error(response.statusText)

        error.response = response
        throw error
    })
}

export function deleteGroupModel(groupModel: GroupModel) {
    return fetch(BASE_SERVICE_URL + '/groupmodel/' + groupModel.uid, {
        credentials: 'same-origin',
        method: 'DELETE'
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}

export function uploadGroupFiles(
    files: { [fileName: string]: File },
    dispatch: (data: FetchFileStatusState) => void
): void {
    if (!files) {
        throw new Error('invalid selected files')
    }

    const formData = new FormData()
    Object.entries(files).forEach(([key, value], _index) => {
        formData.append(key, value)
    })

    fetch(`${BASE_SERVICE_URL}/uploadgroupfiles`, { method: 'POST', body: formData })
        .then(response => response.body)
        .then(body => {
            const reader = body.getReader()

            return new ReadableStream({
                start(controller) {
                    function push() {
                        reader.read().then(({ done, value }) => {
                            if (done) {
                                controller.close()
                                dispatch({ status: [], done: true })
                                return
                            }

                            const parsedValue = parseGroupFilesStreamsResult(value)
                            if (parsedValue !== null) {
                                dispatch({ status: [...parsedValue], done: false })
                            }
                            push()
                        })
                    }
                    push()
                }
            })
        })
}

export function checkGroupFiles(
    groupUID: string,
    fileStatus: FileStatus[],
    dispatch: (data: FetchFileStatusState) => void
) {
    let formData = new FormData()

    const groupFiles = {
        groupUID,
        fileStatus
    }

    return fetch(BASE_SERVICE_URL + '/checkgroupfiles', {
        credentials: 'same-origin',
        method: 'POST',
        body: JSON.stringify(groupFiles)
    })
        .then(response => response.body)
        .then(body => {
            const reader = body.getReader()

            return new ReadableStream({
                start(controller) {
                    function push() {
                        reader.read().then(({ done, value }) => {
                            if (done) {
                                controller.close()
                                dispatch({ status: [], done: true })
                                return
                            }

                            const parsedValue = parseGroupFilesStreamsResult(value)
                            if (parsedValue !== null) {
                                dispatch({ status: [...parsedValue], done: false })
                            }
                            push()
                        })
                    }
                    push()
                }
            })
        })
}

const parseGroupFilesStreamsResult = (rawValue: Uint8Array): FileStatus[] | null => {
    if (!rawValue) {
        return null
    }

    const textValue = new TextDecoder('utf-8').decode(rawValue).trim()
    if (!textValue) {
        return null
    }

    try {
        return textValue.split('\\n').reduce((res, curr) => {
            if (!curr) {
                return res
            }
            res.push(JSON.parse(curr))

            return res
        }, [] as FileStatus[])
    } catch (e) {
        console.error(e)
        return null
    }
}
